export const showDebug = (): boolean => window.location.search.includes('debug')

export const noInfo = (): boolean => window.location.search.includes('no_info')
